export default "__VITE_ASSET__CJCSP9ky__"